<ds-item-detail-preview [item]="dso"
                        [object]="object"
                        [badgeContext]="badgeContext">
</ds-item-detail-preview>

<ds-item-actions [object]="dso"></ds-item-actions>


